<template>
  <div id="render">
    <img src="../assets/img/banner1.jpg" v-if="isDay">
    <img src="../assets/img/banner2.jpg" v-if="!isDay">
  </div>
</template>

<script>

    export default {
        name: 'Render',
        props:  ['isDay'],
        methods: {
            redirect(level, route) {
                if(level > 0 && (this.$route.name === "flats" || this.$route.name === "flatsOfLevel")) {
                    this.$emit('chooseLevel', level);

                } else {
                    this.$router.push(route);
                }

            },
        }
    }
</script>

